import { ApplicationConfig, APP_INITIALIZER, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { DealiodeskTitleStrategy } from './shared/services/dealiodesk-title.strategy';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { UserFriendlyExceptionInterceptor } from './shared/interceptors/user-friendly-exception.interceptor';
import { ConfigService } from './shared/services/config.service';
import { AuthService } from './shared/services/auth.service';
import { providePrimeNG } from 'primeng/config';
import { OverlayModule } from 'primeng/overlay';
import { OverlayModule as CdkOverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { provideNgxMask } from 'ngx-mask';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: DealiodeskTitleStrategy },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    providePrimeNG({
      theme: { 
        preset: Aura,
        options: {
          darkModeSelector: false, // Disable dark mode detection
          cssLayerOrder: 'tailwind-base, primeng'
        }
      },
    }),
    importProvidersFrom(OverlayModule, CdkOverlayModule, PortalModule, DynamicDialogModule),
    MessageService,
    ConfirmationService,
    DialogService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UserFriendlyExceptionInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: (config: ConfigService) => () => config.load(), deps: [ConfigService], multi: true },
    { provide: APP_INITIALIZER, useFactory: (auth: AuthService) => () => auth.scheduleProactiveRefresh(), deps: [AuthService], multi: true },
    provideNgxMask(),
  ]
};
